<template>
    <div class="view-report-page">
        <ViewGeneratorReportPage
            v-if="componentTypeAsNumber === ComponentType.Generator"
            :generator-id="componentSid"
            :report-number="reportNumber"
            :report-type="reportType"
        />

        <ViewTransformatorReportPage
            v-if="componentTypeAsNumber === ComponentType.Transformer"
            :transformer-id="componentSid"
            :report-number="reportNumber"
            :report-type="reportType"
        />
    </div>
</template>

<script setup lang="ts">
import { computed, toRefs } from 'vue'
import { ComponentType } from '@/configuration/component/component-types'
import ViewGeneratorReportPage from '@/pages/reports/view-report-page/generator/ViewGeneratorReportPage.vue'
import ViewTransformatorReportPage from '@/pages/reports/view-report-page/transformator/ViewTransformatorReportPage.vue'

const props = defineProps<{
    componentSid: string
    componentType: string
    reportNumber: string
    reportType: string
}>()

const { componentSid, componentType, reportNumber, reportType } = toRefs(props)

const componentTypeAsNumber = computed(() => Number(componentType.value))
</script>

<style scoped lang="scss">
.view-report-page {
    display: flex;
    flex-direction: column;

    max-height: calc(100vh - $navbar-height * 2);

    &__content {
        @include spacing-page;
        overflow-y: auto;

        display: flex;
        flex-direction: column;
        gap: $spacing-m;
    }
}
</style>
